import { Button, Group, LoadingOverlay, Stack, Text, Textarea } from '@mantine/core';

import { useTSD } from '@hooks/tsd';
import { useRevokePresentationNotificationFormInitializer } from './useRevokePresentationNotificationFormInitializer';

interface SendPresentationNotificationProps {
  onHide(): void;
  tsdId: string;
}

export const RevokePresentationNotification: React.FC<SendPresentationNotificationProps> = ({ onHide, tsdId }) => {
  const { data: tsd, isLoading } = useTSD(tsdId);
  const { form, onSubmit, submitting } = useRevokePresentationNotificationFormInitializer({ tsdId, onHide });

  if (!tsd) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="sm" mb="xl">
        <Stack mb="xl">
          <Text>
            A reason is required to revoke this presentation notification. Enter the reason below, then click Send to proceed or Cancel to abort the action.
          </Text>
          <Textarea
            key={form.key('revocationReason')}
            {...form.getInputProps('revocationReason')}
            placeholder={'Revocation reason'}
            minRows={7}
            autosize
            maxRows={7}
          />
        </Stack>
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} disabled={!form.isValid()} variant="filled" size="lg" data-pw="create-btn">
          Send
        </Button>
      </Group>
    </form>
  );
};
